import { FC } from 'react';
import styled from 'styled-components';
import COLORS from 'lib/constants/colors';
import ErrorMessage from './ErrorMessage';

const Container = styled.div`
  label {
    overflow: hidden;
    display: inline-block;
    border-radius: 5px;
    cursor: pointer;
    position: relative;
    user-select: none;
    transition: border-color 0.1s;
    border: 0;
    background: transparent;
    width: auto;
    height: auto;
    font-weight: normal;
  }

  input:checked ~ .option-inner i:before {
    background-color: ${COLORS.pink};
    transform: scale(1);
  }

  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    top: -20px;
    left: -20px;
  }

  .option-inner {
    padding: 0;
    display: flex;
    align-items: center;
  }

  .option-inner-icon {
    flex: 30 0 auto;
    border-color: #b7b7b7;
    order: -1;
    margin-right: 10px;
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px #dadada solid;
    background: #fff;
    border-radius: 5px;
    position: relative;
    transition: border-color 0.1s, background-color 0.1s;

    :before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 5px;
      transform: scale(0);
      transition: transform 0.1s;
    }

    :after {
      content: ' ';
      background-repeat: no-repeat;
      background-image: url('/static/images/tick.png');
      background-position: center;
      position: absolute;
      z-index: 1;
      display: block;
      overflow: hidden;
      content: '';
      top: 50%;
      left: 50%;
      width: 20px;
      height: 20px;
      background-size: contain;
      transform: translate(-50%, -50%);
    }
  }
`;

const CheckBox: FC<{
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label: React.ReactElement | React.ReactText;
  name: string;
  inputRef?: React.Ref<HTMLInputElement>;
  errorMessage?: string;
}> = ({ checked, label, onChange, name, inputRef, errorMessage }) => (
  <Container>
    <label htmlFor={name} className="input-cbx inline">
      <input
        id={name}
        ref={inputRef}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={(event) => {
          if (onChange) onChange(event.target.checked);
        }}
      />
      <div className="option-inner">
        <p className="option-inner-text">{label}</p>
        <i className="option-inner-icon" />
      </div>
    </label>
    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
  </Container>
);

export default CheckBox;
